import { Injectable } from '@angular/core';

// CR-20260424-003 — Carries a logout reason from the publisher of
// AuthTokenExpiredUIMessage to LogoutComponent.ngOnInit so the logout
// screen can show a contextual message (FR-5.b). Singleton lives across
// the /logout route navigation because @Injectable({providedIn: 'root'})
// is application-scoped.

export type LogoutReason = 'UILagDetected' | string;

export const LOGOUT_REASON_UI_LAG = 'Logging you out due to UI lag. Please log in again.';

@Injectable({
   providedIn: 'root'
})
export class LogoutReasonService {

   private _reason: LogoutReason | undefined;

   setReason(reason: LogoutReason): void {
      this._reason = reason;
   }

   getAndClearReason(): LogoutReason | undefined {
      const value = this._reason;
      this._reason = undefined;
      return value;
   }
}
